module.exports = __webpack_public_path__ + "img/ring_y_e_null_1.a03b581a.png";